<template>
  <div>
    <template v-if="isEntryRoute || isDetailRouteWithoutParameter">
      <entity-entry-header :entityKey="eCurrent.key" :title="$t(`views.${eCurrent.key}.title`)" />
    </template>

    <!-- if this is active route (e.g. /users) -->
    <template v-if="isEntryRoute">
      <b-row class="mb-3" align-h="between">
        <b-col cols="auto"></b-col>
        <b-col cols="auto">
          <b-button variant="outline-primary" @click="navigate('Vouchers.Add')"><b-icon icon="plus" /> {{ $t('views.vouchers.button.addvoucher') }}</b-button>
        </b-col>
      </b-row>

      <entity-entry-table :entityKey="eCurrent.key" :tableSettings="table" searchable>
        <template #cell(usecount)="data">
          {{ data.cell.value ? data.cell.value : '0' }}
        </template>
        <template #cell(sumamount)="data">
          {{ data.cell.value ? data.cell.value.toFixed(2) : '-' }}
        </template>
        <template #cell(validfrom)="data">
          {{ data.cell.value ? $d(new Date(data.cell.value), 'short') : '-' }}
        </template>
        <template #cell(validto)="data">
          {{ data.cell.value ? $d(new Date(data.cell.value), 'short') : '-' }}
        </template>
      </entity-entry-table>
    </template>

    <!-- if subroute is active route (e.g. /users/detail/:userid) -->
    <section v-else-if="isDetailRouteWithParameter">
      <router-view />
    </section>

    <!-- if subroute is active route (e.g. /users/add) -->
    <router-view v-else-if="isDetailRouteWithoutParameter" />
  </div>
</template>

<script>
import { CLASS_TABLE_FIELD_KEY_UNKNOWN } from '@/assets/js/config/client'

import { TableHelper } from '@/assets/js/helper/table'

import EntityEntryHeader from '@/components/entity/EntryHeader'
import EntityEntryTable from '@/components/entity/EntryTable'
import MixinEntityBase from '@/components/mixins/EntityBase'

const ENTITY_KEY = 'vouchers'

export default {
  name: 'Vouchers',
  mixins: [MixinEntityBase],
  components: {
    EntityEntryHeader,
    EntityEntryTable
  },
  data () {
    return {
      entityKey: ENTITY_KEY,
      table: {
        helper: TableHelper,
        mapper: this.tableEntitiesMapper,
        options: {
          fields: {
            sorting: [CLASS_TABLE_FIELD_KEY_UNKNOWN],
            labelKey: `views.${this.$options.name.toLowerCase()}.table.label.{field}`
          }
        },
        events: {
          rowClicked: this.tableRowClicked
        }
      }
    }
  },
  computed: {
    isEntryRoute () {
      return Object.values(this.$route.matched[this.$route.matched.length - 1].components).find(c => c.name === this.$options.name) !== undefined
    },
    isDetailRouteWithParameter () {
      return this.$route.matched[this.$route.matched.length - 1].path.indexOf(`/:${this.eCurrent.paramKey}`) >= 0
    },
    isDetailRouteWithoutParameter () {
      return !this.isEntryRoute && !this.isDetailRouteWithParameter
    }
  },
  methods: {
    tableEntitiesMapper (entities, definition) {
      return entities
        .map(e => Object.assign({}, e, {
          $routerLink: {
            name: `${this.$options.name}.Detail`,
            params: {
              [this.eCurrent.paramKey]: e.id
            }
          }
        }))
    },
    tableRowClicked (entity) {
      this.$router.push(entity.$routerLink)
    }
  },
  created () {
    TableHelper.rowClassHook(entity => entity.$routerLink ? 'has-routerlink' : null)
  }
}
</script>

<style lang="scss"></style>
